import { HubStreamResponseError } from "./hubStreamResponseError";
import { fetchHubLiveStream } from "./hubStreamFetch";
import { parseHubLiveSseDataLine, type HubLiveSseEvent } from "./hubLiveEvents";
import { hubLiveStreamUrl } from "./hubLiveChannelUnion";

export type HubLiveOwnerOptions = {
  streamUrl: string;
  authorization: string;
  channels: readonly string[];
  signal?: AbortSignal;
  onEvent: (event: HubLiveSseEvent) => void;
};

export async function connectHubLiveOwner(options: HubLiveOwnerOptions): Promise<void> {
  const headers: Record<string, string> = {};
  if (options.authorization !== "") {
    headers.Authorization = options.authorization;
  }
  const response = await fetchHubLiveStream(hubLiveStreamUrl(options.streamUrl, options.channels), {
    headers,
    signal: options.signal,
  });
  if (!response.ok) {
    throw new HubStreamResponseError("Hub live stream", response.status);
  }
  const reader = response.body?.getReader();
  if (reader == null) {
    throw new Error("Hub live stream returned no body.");
  }
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    buffer += decoder.decode(value, { stream: true });
    let newlineIndex = buffer.indexOf("\n");
    while (newlineIndex !== -1) {
      const line = buffer.slice(0, newlineIndex).trimEnd();
      buffer = buffer.slice(newlineIndex + 1);
      const event = parseHubLiveSseDataLine(line);
      if (event != null) {
        options.onEvent(event);
      }
      newlineIndex = buffer.indexOf("\n");
    }
  }
}
